import { ICreateControleResiduoUseCase } from "../../../presentation/useCases/create/create_controle_residuo_use_case";
import { CreateControleResiduoRequestModel, CreateControleResiduoResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateControleResiduoUseCase
 */

export class CreateControleResiduoUseCase implements ICreateControleResiduoUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async createControleResiduo(model: CreateControleResiduoRequestModel): Promise<CreateControleResiduoResponseModel> {
    return await this.repository.createControleResiduo(model);
  }
}
